/**
 * Header Rent — drawer visible con cabecera «on-scroll-up» oculta a mitad de página.
 * Spec: specs/header-footer/spec.md
 */
(function () {
  function headerHeightPx() {
    const parsed = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  function setHeaderBottomPosition(borderOffset) {
    const sectionHeader = document.querySelector('.section-header');
    const menuOpen = sectionHeader?.classList.contains('menu-open');
    const measureEl =
      (menuOpen && document.querySelector('.header-wrapper')) || document.querySelector('.header');
    if (!measureEl) return;

    let bottom = Math.round(measureEl.getBoundingClientRect().bottom - (borderOffset || 0));

    /* --header-height = .section-header (incluye margin-bottom); no usar como mínimo con menú abierto */
    if (bottom <= 0) {
      const fallback = headerHeightPx();
      if (fallback > 0) bottom = fallback;
    }

    document.documentElement.style.setProperty('--header-bottom-position', `${Math.max(0, bottom)}px`);
  }

  function syncHeaderBottomAfterOpen(drawerInstance) {
    setHeaderBottomPosition(drawerInstance.borderOffset);
    requestAnimationFrame(() => {
      setHeaderBottomPosition(drawerInstance.borderOffset);
      requestAnimationFrame(() => setHeaderBottomPosition(drawerInstance.borderOffset));
    });
  }

  function patchHeaderDrawer() {
    const HeaderDrawer = customElements.get('header-drawer');
    if (!HeaderDrawer || HeaderDrawer.prototype.__rentHeaderDrawerPatched) return;

    const openOriginal = HeaderDrawer.prototype.openMenuDrawer;
    const resizeOriginal = HeaderDrawer.prototype.onResize;

    HeaderDrawer.prototype.openMenuDrawer = function (summaryElement) {
      const sectionHeader = document.querySelector('.section-header');
      if (sectionHeader) {
        sectionHeader.classList.remove('shopify-section-header-hidden');
        sectionHeader.classList.add('shopify-section-header-sticky', 'animate');
      }

      document.querySelector('sticky-header')?.dispatchEvent(new Event('preventHeaderReveal'));

      openOriginal.call(this, summaryElement);

      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      syncHeaderBottomAfterOpen(this);
    };

    HeaderDrawer.prototype.onResize = function () {
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

      if (this.header?.classList.contains('menu-open')) {
        setHeaderBottomPosition(this.borderOffset);
        return;
      }

      if (typeof resizeOriginal === 'function') {
        resizeOriginal.call(this);
      }
    };

    HeaderDrawer.prototype.__rentHeaderDrawerPatched = true;
  }

  function extractSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const match = doc.querySelector(selector);
    if (match) return match.innerHTML;
    const sectionRoot = doc.querySelector('[id^="shopify-section-"]');
    if (sectionRoot) return sectionRoot.innerHTML;
    return doc.body?.innerHTML?.trim() || '';
  }

  async function refreshCartIconBubbleFromServer() {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon || typeof routes === 'undefined') return;

    const cartUrl = routes.cart_url || '/cart';
    const data = await fetch(`${cartUrl}?sections=cart-icon-bubble`, {
      headers: { Accept: 'application/json' },
    })
      .then((response) => (response.ok ? response.json() : null))
      .catch(() => null);

    const html = data?.['cart-icon-bubble'];
    const inner = extractSectionInnerHTML(html);
    if (inner) cartIcon.innerHTML = inner;
  }

  function patchCartIconBubbleOnUpdate() {
    if (typeof subscribe !== 'function' || !window.PUB_SUB_EVENTS?.cartUpdate) return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      document.querySelector('sticky-header')?.reveal?.();

      const count = event?.cartData?.item_count;
      if (typeof count !== 'number') return;

      const cartIcon = document.getElementById('cart-icon-bubble');
      if (!cartIcon) return;

      const hasBubble = !!cartIcon.querySelector('.cart-count-bubble');
      if (count > 0 && !hasBubble) {
        refreshCartIconBubbleFromServer();
      }
    });
  }

  if (customElements.get('header-drawer')) {
    patchHeaderDrawer();
  } else {
    customElements.whenDefined('header-drawer').then(patchHeaderDrawer);
  }

  patchCartIconBubbleOnUpdate();
})();
